import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import Logo from '@/components/Logo';
import Account from '@/icons/account.svg';
import routes from '@/routes';
import { localizedRoute } from '@/utils/locale';

function Header() {
	const { firstName, lastName, email } = useSelector(
		state => state.profile.user
	);

	let userName = email;

	if (firstName) {
		userName = `${firstName} ${lastName || ''}`;
	}

	return (
		<>
			<header className="fixed z-20 flex h-[48px] w-full items-center justify-between bg-black px-5 lg:h-[64px] lg:px-6">
				<Logo />

				<Link
					className="relative flex items-center gap-2 px-0 underline-offset-4 hover:underline"
					to={localizedRoute(routes.checkout)}
				>
					<p className="text-xs leading-5 text-white md:text-sm md:leading-6">{`${userName}`}</p>
					<Account className="h-5 w-5 text-white" />
				</Link>
			</header>
			<div className="h-[48px] lg:h-[64px]" />
		</>
	);
}

export default Header;
